import React from "react";
import {
  Avatar,
  Tag,
  Card,
  Dropdown,
  Menu,
  Input,
  Button,
  Typography,
  Space,
  Divider,
} from "antd";
import {
  UserOutlined,
  LogoutOutlined,
  SettingOutlined,
  QuestionCircleOutlined,
  BellOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import team30 from "src/assets/img/team/30.webp";
import coreFunctions from "src/common/utils/coreFunctions";

const { Text } = Typography;

const ProfileDropdownMenu: React.FC = () => {
  const navigate = useNavigate();

  const navItems = [
    {
      label: "Profile",
      icon: <UserOutlined />,
      path: "user/profile/profile_settings",
    },
    // { label: "Dashboard", icon: <PieChartOutlined />, path: "user/profile" },
    {
      label: "Notifications",
      icon: <BellOutlined />,
      path: "user/profile/notification_preferences",
    },
    {
      label: "Settings & Privacy",
      icon: <SettingOutlined />,
      path: "user/profile/account_settings",
    },
    {
      label: "Help Center",
      icon: <QuestionCircleOutlined />,
      path: "user/profile",
    },
  ];

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  const menu = (
    <Card
      bordered={false}
      style={{
        width: "300px",
        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
        borderRadius: "8px",
      }}
    >
      {/* User Info Section */}
      <Space
        direction="vertical"
        align="center"
        style={{ width: "100%" }}
        size={2}
      >
        <Avatar
          size={40}
          src={localStorage.getItem("profile_image") ?? team30}
        />
        <motion.div animate={{ scale: [0, 1] }}>
          <Tag color="blue">
            {`Hello ${localStorage.getItem("role")?.toUpperCase() || "USER"}!`}
          </Tag>
        </motion.div>
        <motion.div animate={{ scale: [0, 1] }} transition={{ delay: 0.3 }}>
          <Text type="secondary">
            PL:{" "}
            {localStorage.getItem("last_logined") !== "null"
              ? localStorage.getItem("last_logined")
              : "N/A"}
          </Text>
        </motion.div>
        <Input
          placeholder="Update your status"
          size="small"
          style={{
            borderRadius: "4px",
            width: "100%",
          }}
        />
      </Space>

      <Divider style={{ margin: "8px 0" }} />

      <Menu style={{ border: "none", boxShadow: "none" }}>
        {navItems.map((item) => (
          <Menu.Item
            key={item.label}
            icon={item.icon}
            onClick={() => {
              navigate(`/${item.path}`);
            }}
          >
            {item.label}
          </Menu.Item>
        ))}

        <Divider style={{ margin: "8px 0" }} />
        {/* <Menu.Item key="add-account" icon={<UserAddOutlined />}>
          Add another account
        </Menu.Item> */}
        <Menu.Item
          key="logout"
          icon={<LogoutOutlined />}
          onClick={handleLogout}
          style={{ padding: "8px 16px" }}
        >
          Sign out
        </Menu.Item>
      </Menu>

      <Divider style={{ margin: "8px 0" }} />

      {/* Footer Links */}
      <Space
        direction="horizontal"
        size="small"
        style={{ justifyContent: "center", width: "100%" }}
      >
        <Text type="secondary">
          <a href="#!" style={{ color: "#8c8c8c" }}>
            Privacy policy
          </a>
        </Text>
        <Text type="secondary">•</Text>
        <Text type="secondary">
          <a href="#!" style={{ color: "#8c8c8c" }}>
            Terms
          </a>
        </Text>
        <Text type="secondary">•</Text>
        <Text type="secondary">
          <a href="#!" style={{ color: "#8c8c8c" }}>
            Cookies
          </a>
        </Text>
      </Space>
    </Card>
  );

  return coreFunctions.isMobileDevice() ? (
    <Button
      type="text"
      icon={
        <Avatar
          size="large"
          src={localStorage.getItem("profile_image") ?? team30}
        />
      }
      onClick={() => navigate("/profile")}
      style={{ border: "none", boxShadow: "none" }}
    />
  ) : (
    <Dropdown
      overlay={menu}
      trigger={["click"]}
      placement="bottomRight"
      overlayStyle={{ padding: 0 }}
    >
      <Button
        type="text"
        icon={
          <Avatar
            size="large"
            src={localStorage.getItem("profile_image") ?? team30}
          />
        }
        style={{ border: "none", boxShadow: "none" }}
      />
    </Dropdown>
  );
};

export default ProfileDropdownMenu;
